import type { FunctionComponent } from 'react';

import { L10nText } from '../../../services/uiTranslations/reactBindings/L10nText';
import { useConfigSlice } from '../../../store/slices/config/selectors';
import { useHeaderSlice } from '../../../store/slices/header/selectors';

import { useDelayedRouteByLevel } from './hooks';
import { NavPages } from './NavPagesConnected';

export const NavPagesTitleConnected: FunctionComponent = () => {
  const routeLevelLength = useHeaderSlice.getNavRouteLevel();
  const currentNavRoute = useHeaderSlice.getNavRouteByLevel(routeLevelLength);
  const isPrivateTable = useConfigSlice.isPrivateTable();
  const delayedRouteByLevel = useDelayedRouteByLevel({ skipDelay: routeLevelLength !== 0 });

  switch (delayedRouteByLevel) {
    case NavPages.SUPPORT:
      return <L10nText tk="LIVE_SUPPORT" />;
    case NavPages.CHAT:
      return <L10nText tk={isPrivateTable ? 'PRIVATE_CHAT' : 'CHAT'} />;
    case NavPages.SETTINGS:
      return <L10nText tk={currentNavRoute ?? 'SETTINGS'} />;
    case NavPages.HISTORY:
      return <L10nText tk="HISTORY" />;
    case NavPages.BET_LIMITS:
      return <L10nText tk="MENU_PAYOUTS_LIMITS" />;
    case NavPages.HELP:
      return <L10nText tk="HELP" />;
    case NavPages.QUICK_GUIDE:
      return <L10nText tk="QG_QUICK_GUIDE" />;
    default:
      return <L10nText tk="MENU" />;
  }
};
